module.exports = __webpack_public_path__ + "static/pinkfloralbummain-133b1f3656f92c06f4b4b99369b1799b.jpeg";